module.exports = __webpack_public_path__ + "img/multi-platform.cc036d1b.svg";